import { useSearchParams } from 'react-router-dom';
import { MembershipPaymentSuccess } from '../components';

export function PaymentSuccessPage() {
   const [searchParams] = useSearchParams();
   const type = searchParams.get('type');

   switch (type) {
      case 'membership':
         return <MembershipPaymentSuccess />;
      default:
         return null;
   }
}
